import { FormControl, FormLabel, TextField } from '@mui/material';
import { eachDeep } from 'deepdash-es/standalone';
import { cloneDeep, debounce } from 'lodash';
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { treeActions } from '../../redux/slices/treeSlice';

function Description({ label }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
    const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
    const selectedNode = useSelector((state) => state.treeData[parentScreen].rightTree.tree.body.selectedNode);
    const [description, setDescription] = useState();

    const submitChange = (key, val) => {
        const updatedData = eachDeep(cloneDeep(translatedData), (objValue) => {
            if (objValue?.key !== selectedNode.key) {
                return;
            }
            if (objValue.key === selectedNode?.key) {
                // objValue['DESCRIPTION'] = val;
                objValue[key] = (val)
            }
            dispatch(
                treeActions.setRightTreeSelectedNode({
                    screen: parentScreen,
                    type: rightTree.currentTab,
                    data: objValue,
                })
            );
        });
        dispatch(
            treeActions.setNewRightTreeTranslatedData({
                screen: parentScreen,
                type: rightTree.currentTab,
                data: updatedData,
            })
        );
    };

    const debounceChangeHandler = useCallback(debounce(submitChange, 500), [
        rightTree.currentTab,
        rightTree.tree,
    ]);

    useEffect(() => {
        if (selectedNode) {
            const description = label && selectedNode?.COMMENTS 
                ? selectedNode?.COMMENTS 
                : selectedNode?.DESCRIPTION || '';
            setDescription((description));
        }
        
    }, [selectedNode.key])

    return (
        <div className="height-100 padding-12">
            <div className={"height-100"}>
                <div>
                    <FormControl
                        className="width-100"
                        size="small"
                    >
                        <FormLabel>{label ? label + ' ' + t('LBL_DESC') : t("LBL_DESC")}</FormLabel>
                        <TextField
                            className="text-field-scroll width-100"
                            sx={{marginTop:'6px'}}
                            // autoFocus={true}
                            multiline={true}
                            rows={10}
                            size="small"
                            type="text"
                            variant='outlined'
                            value={description}
                            onChange={(e) => {
                                setDescription(e.target.value);
                                debounceChangeHandler(label ? 'COMMENTS' :'DESCRIPTION', e.target.value);
                            }}
                        />
                    </FormControl>
                </div>
            </div>
        </div>
    )
}

export default Description